/** Chat-agent glossary nouns and entity descriptions, base (legal) dialect - consumed by the backend chat glossary builder. */
export const glossary = {
    account: {
        singular: 'firm',
        plural: 'firms',
        /** Comma-separated other names for the account. No "company": the context block states its legal form. */
        aliases: 'practice, law firm',
        description: 'A legal practice or law firm that uses the billing platform.',
    },
    client: {
        description: 'A person or organisation the firm bills for legal work.',
    },
    clientProject: {
        singular: 'matter',
        plural: 'matters',
        description: 'A legal matter or case the firm is handling for a client.',
    },
    clientProjectActivity: {
        description: 'A time entry or disbursement recorded against a matter. The description field is called a "narration" in SA legal billing.',
    },
    user: {
        description: 'A person who uses the platform, typically a legal professional.',
    },
    /** The fee-side line word (activity alias). */
    fee: 'fee',
    /** The disbursement-side line word (activity alias). */
    disbursement: 'disbursement',
};
